module.exports = {"LOGIN":{"SIGN_IN":"Prihlásiť sa"},"ACTIONS":{"NEXT":"Next","SUBMIT":"Submit","YES":"Yes","NO":"No","CANCEL":"Cancel","BACK":"Back"},"BASIC":{"EMAIL":"E-mail","PASSWORD":"Password"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/en.json
// module id = 346
// module chunks = 0